import { keyframes } from '@emotion/react';
import { styled } from '@sds-system/system';
import { getAllStyledProps } from '@sds-system/utils';
import type { StyledProgressBarFillProps, StyledProgressBarRootProps } from './ProgressBar.types';

const progress = keyframes`
    from { width:0px; }
    to { width:100%; }
`;

export const ProgressBarRoot = styled('div')<StyledProgressBarRootProps>(({ theme }) => {
  return {
    width: 312,
    height: theme.space[8],
    backgroundColor: theme.palette.bg.secondary,
    borderRadius: 10,
  };
}, getAllStyledProps);

export const ProgressBarFill = styled('div')<StyledProgressBarFillProps>(
  ({ theme, time, percent }) => {
    return {
      maxWidth: '100%',
      height: theme.space[8],
      backgroundColor: theme.palette.bg.interactive.primary,
      borderRadius: 10,
      ...(time
        ? {
            animation: `${progress} ${time / 1000}s`,
          }
        : { transitionProperty: 'width', transitionDuration: `0.5s`, width: percent + '%' }),
    };
  },
  getAllStyledProps,
);
